import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import MessagePanel from '../../../common/components/MessagePanel/MessagePanel';
import { ValidationContext } from '../../../providers/ValidationContext';
import { Routes } from '../../../config/routes';
import { FlowConfigContext } from '../../../providers/FlowConfigContext';
import withRouteAnalytics from '../../../services/analytics/withRouteAnalytics';
import { Screens } from '../../../services/analytics/screens';
import { ExchangeTokenData } from '../../../services/authentication';
import { ScopeRequestContext } from '../../../providers/ScopeRequestContext';

function LinkDevicesScreen(): JSX.Element {
  const { initialized, getOptionalFlowExecutionConfig } = useContext(FlowConfigContext);
  const navigate = useNavigate();
  const [linkToken, setLinkToken] = useState<string | null>(null);
  const [linked, setLinked] = useState<boolean>(false);
  const { activateDeviceLinkToken, getRouteForNextStep } = useContext(ValidationContext);
  const [exchangeTokenData, setExchangeTokenData] = useState<ExchangeTokenData>();
  const {loadScopeRequestByUuid} = useContext(ScopeRequestContext);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!initialized) {
      return;
    }

    setLinkToken(getOptionalFlowExecutionConfig('token'));
  }, [initialized]);

  const activateToken = async () => {
    setLoading(true);
    if (!linkToken) {
      return;
    }
    const activationResult = await activateDeviceLinkToken(linkToken);
    if (activationResult.isFailed()) {
      // if activation fails show generic failure screen
      navigate(Routes.VALIDATION_ERROR, { state: { error: activationResult.failure() } });
      return;
    }
    setExchangeTokenData(activationResult.success())
    setLoading(false)
    setLinked(true);
  };

  useEffect(() => {
    activateToken();
  }, [linkToken]);

  const onConfirm = async () => {
    setLoading(true)

    //if there is a scopeRequestId load it
    if (exchangeTokenData?.scopeRequestId) {
      await loadScopeRequestByUuid(exchangeTokenData.scopeRequestId);
    }
    setLoading(false)
    const route = await getRouteForNextStep();
    if (route) navigate(route);
  };

  return (
    <MessagePanel
      title={`screens.documentPass.linkDevices.title${linked ? 'Linked' : ''}`}
      description="screens.documentPass.linkDevices.description"
      dataTestId="LINK_DEVICES"
      loading={loading}
      buttonLabel="screens.documentPass.linkDevices.continueButton"
      showSupportLink={false}
      onConfirm={onConfirm}
    />
  );
}
export default withRouteAnalytics(LinkDevicesScreen, Screens.DOCUMENT_MOBILE_HANDOFF_LINKED_DESKTOP);
